import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getDataViewKey } from "@insite/client-framework/Store/Data/DataState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { PaginationModel } from "@insite/client-framework/Types/ApiModels";
import { AccountCustomersCollectionModel } from "@store/Types/ApiModels";
import { AccountCustomerModel } from "@store/Types/ApiModels";
import { Draft } from "immer";

export interface StoreCustomerStateType {
    readonly dataViews: SafeDictionary<DataView>;
}

const initialCustomerState: StoreCustomerStateType = {
    dataViews: {},
};

interface DataView {
    readonly isLoading: boolean;
    pagination: PaginationModel | null;
    value?: AccountCustomerModel[];
}

export const customersReducer = createTypedReducerWithImmer(initialCustomerState, {
    "Data/AccountCustomers/BeginLoadAccountCustomersCollection": (
        draft: Draft<StoreCustomerStateType>,
        action: { parameter: object },
    ) => {
        draft.dataViews[getDataViewKey(action.parameter)] = {
            isLoading: true,
            pagination: null,
        };
    },
    "Data/AccountCustomers/CompleteLoadAccountCustomersCollection": (
        draft: Draft<StoreCustomerStateType>,
        action: { parameter: object; collection: AccountCustomersCollectionModel },
    ) => {
        const dataView = {
            isLoading: false,
            value: action.collection.userCustomerCollection!,
            pagination: action.collection.pagination,
        };
        draft.dataViews[getDataViewKey(action.parameter)] = dataView;
    },
    "Data/AccountCustomers/Reset": () => {
        return initialCustomerState;
    },
});

(reducers as any).customersReducer = customersReducer;

export type StoreCustomerState = {
    customersReducer: StoreCustomerStateType;
} & ApplicationState;

type Reducers = {
    customersReducer: typeof customersReducer;
};

export type StoreCustomerActions = Parameters<Reducers[keyof Reducers]>[1] | AnyAction;
